import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ExpandIcon = forwardRef<SVGSVGElement, IconProps>(function ExpandIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54437 1.54437C2.6616 0.427145 4.33342 0 6.48837 0H11.5116C13.6666 0 15.3384 0.427145 16.4556 1.54437C17.5729 2.6616 18 4.33342 18 6.48837V11.5116C18 13.6666 17.5729 15.3384 16.4556 16.4556C15.3384 17.5729 13.6666 18 11.5116 18H6.48837C4.33342 18 2.6616 17.5729 1.54437 16.4556C0.427145 15.3384 0 13.6666 0 11.5116V6.48837C0 4.33342 0.427145 2.6616 1.54437 1.54437ZM2.43237 2.43237C1.66588 3.19886 1.25581 4.45728 1.25581 6.48837V11.5116C1.25581 13.5427 1.66588 14.8011 2.43237 15.5676C3.19886 16.3341 4.45728 16.7442 6.48837 16.7442H11.5116C13.5427 16.7442 14.8011 16.3341 15.5676 15.5676C16.3341 14.8011 16.7442 13.5427 16.7442 11.5116V6.48837C16.7442 4.45728 16.3341 3.19886 15.5676 2.43237C14.8011 1.66588 13.5427 1.25581 11.5116 1.25581H6.48837C4.45728 1.25581 3.19886 1.66588 2.43237 2.43237Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4673 3.53275C14.7125 3.77796 14.7125 4.17553 14.4673 4.42074L4.42074 14.4673C4.17553 14.7125 3.77796 14.7125 3.53275 14.4673C3.28753 14.222 3.28753 13.8245 3.53275 13.5793L13.5793 3.53275C13.8245 3.28753 14.222 3.28753 14.4673 3.53275Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0465 3.97674C10.0465 3.62996 10.3276 3.34884 10.6744 3.34884H14.0233C14.37 3.34884 14.6512 3.62996 14.6512 3.97674V7.32558C14.6512 7.67236 14.37 7.95349 14.0233 7.95349C13.6765 7.95349 13.3953 7.67236 13.3953 7.32558V4.60465H10.6744C10.3276 4.60465 10.0465 4.32353 10.0465 3.97674Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.97674 10.0465C4.32353 10.0465 4.60465 10.3276 4.60465 10.6744V13.3953H7.32558C7.67236 13.3953 7.95349 13.6765 7.95349 14.0233C7.95349 14.37 7.67236 14.6512 7.32558 14.6512H3.97674C3.62996 14.6512 3.34884 14.37 3.34884 14.0233V10.6744C3.34884 10.3276 3.62996 10.0465 3.97674 10.0465Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
